<template>
  <div>
    <div class="query" v-if="showQuery">
      <lk-breadcrumb class="breadcrumb" v-if="!hideBreadcrumb">
        <lk-breadcrumb-item v-for="item in breadcrumb" :key='item.name' :to="{name:item.name}">
          {{item.title}}
        </lk-breadcrumb-item>
      </lk-breadcrumb>
      <div v-if="showEmptyLine" style="background-color: white; height: 8px;"></div>
      <div>
        <div ref="paramsField" class="params" @click="handleSize(true)">
          <div ref="paramsInside">
            <slot name="queryParams"></slot>
          </div>
        </div>
        <div class="sizeBar" v-if="sideBarShow">
          <span class="handleSize" @click="handleSize">{{isOpen?'展开':'收起'}} <lk-icon :type='isOpen?"ios-arrow-down":"ios-arrow-up"'></lk-icon> </span>
        </div>
      </div>
    </div>
    <div :class="{'content':true,'noBar':!sideBarShow}">
      <lk-card >
        <loadingSpan v-if='loading' fix>加载中...</loadingSpan>
        <div >

        <div class="btns" v-if="addText||customedText">
          <lk-button :disabled="disableAdd" type='primary' icon='md-add'  @click="addNew" v-if="addText">{{addText}}</lk-button>
          <lk-button :disabled="disableCustomed" type='primary' @click="handleCustomed" v-if="customedText">{{customedText}}</lk-button>
          <div>

          </div>
        </div>
        <slot name='table'></slot>
        <lk-Page
          class="pages"
          show-sizer
          show-elevator
          show-total
          :page-size="size"
          v-if="!disablePage"
          @on-page-size-change='handlePageSize'
          @on-change='handlePage'
          :total = 'count'
          :page-size-opts='[20,30,50,100]'
          :current="current"
        ></lk-Page>
        </div>
      </lk-card>
      <DTPModal
        @confirm='handleConfirm'
        v-model="ctrlModal"
        :content='modalContent'
      ></DTPModal>
    </div>
  </div>
</template>
<script>
import DTPModal from '../DTPModal.vue';
import loadingSpan from '../LoadingSpan.vue';
import utils from '../../libs/utils';

export default {
  components: {
    DTPModal, loadingSpan,
  },
  name: 'queryFrame',
  props: {
    queryParams: {
      type: Object,
    },
    page: {
      type: Number,
    },
    ctrlModal: {
      type: Boolean,
      default: false,

    },
    modalContent: {
      type: String,
    },
    menuTitle: {
      type: String,
    },
    count: {
      type: Number,
    },
    addText: {
      type: String,
      default: '',
    },
    customedText: {
      type: String,
      default: '',
    },
    disableCustomed: {
      type: Boolean,
      default: false,
    },
    disableAdd: {
      type: Boolean,
      default: false,
    },
    disablePage: {
      type: Boolean,
      default: false,
    },
    hideBreadcrumb: {
      type: Boolean,
      default: false,
    },
    current: {
      type: Number,
      default: 1,
    },
    size: {
      type: Number,
      default: 20,
    },
    showQuery: {
      type: Boolean,
      default: true,
    },
    showEmptyLine: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    disablePage(val) {
      if (!val) {
        this.resetPage();
      }
    },
  },
  computed: {
    loading() {
      return this.$store.state.app.loading;
    },
    breadcrumb() {
      const breadcrumb = [{
        name: this.$route.meta.menuNav,
        title: this.$route.meta.parentTitle,
      },
        // this.$route.meta.parentTitle,
      ];
      if (this.$route.meta.subTitle) {
        breadcrumb.push({
        // name: this.$route.meta.menuNav,
          title: this.$route.meta.subTitle,
        });
      }
      return breadcrumb;
    },
  },
  data() {
    return {
      isOpen: false,
      sideBarShow: true,
    };
  },
  mounted() {
    if (this.showQuery) {
      this.$nextTick(() => {
        let isEmptyParams = {};
        if (this.$parent && this.$parent.saveQuery && this.$parent.saveQuery.routerName === this.$parent.$route.name) {
          isEmptyParams = utils.deepClone(this.$parent.saveQuery.query);
        } else {
          isEmptyParams = utils.deepClone(this.$parent.query);
        }
        if (isEmptyParams) {
          const queryObjIsNll = utils.isDefaults(utils.deletePageAndSize(isEmptyParams));
          this.handleSize(!queryObjIsNll);
        } else {
          this.handleSize();
        }
      });
    }
    if (!(this.$refs.paramsInside && this.$refs.paramsInside.clientHeight > 70)) {
      this.sideBarShow = false;
    }
  },
  methods: {
    resetPage() {
      this.current = 1;
      this.size = 20;
    },
    handleSize(onlyOpten) {
      this.isOpen = !this.isOpen;
      if (onlyOpten === true) {
        this.isOpen = false;
      }
      // console.dir(this.$refs.paramsInside.clientHeight);
      // console.dir(this.$refs.paramsField.clientHeight);
      if (this.isOpen) {
        if (this.showEmptyLine) {
          this.$refs.paramsField.style.height = '0px';
        } else {
          this.$refs.paramsField.style.height = '45px';
        }
      } else {
        this.$refs.paramsField.style.height = 'auto';
      }
    },
    handleConfirm() {
      this.$emit('confirm');
    },
    handlePage(page) {
      this.$emit('handlePage', page);
    },
    handlePageSize(size) {
      this.$emit('handlePageSize', size);
    },
    addNew() {
      this.$emit('addNew');
    },
    open() {
      this.$emit('open');
    },
    handleCustomed() {
      this.$emit('handleCustomed');
    },
    cancel() {
      this.$emit('block');
    },
    print() {
      this.$emit('print');
    },
    deleteItem() {
      this.$emit('deleteItem');
    },
  },
};
</script>
<style lang="less" scoped>
.content{
  padding: 16px;
  padding-top: 30px;
  // position:relative;
  // min-height:calc(~'100vh - 168px')

}
.noBar{
  padding-top: 16px;

}
.pages{
  margin-top: 16px;
  text-align: right
}
.btns{
  display: flex;
  // justify-content: space-between;
  margin-bottom: 12px;
  margin-top:2px;
  // padding-top: 16px;
  div:last-child>*{
    margin-left: 16px
  }
   >*:first-child{
     margin-right: 16px
   }


}
.query{
  background: #fff;
  padding-left: 32px;
  padding-top: 21px;
  transition: all 1s;
.breadcrumb{
  margin-bottom: 14px
}
.params{
  overflow: hidden;
  transition: all 0.5s;
  // position: relative;
}
.sizeBar{
  // display: flex;
  // position: absolute;
  // bottom: 0;
  padding-right: 32px;
  height: 5px;
  .handleSize{

    cursor: pointer;
    display: block;
    width: 72px;
    line-height: 25px;
    font-size: 12px;
    margin: 0 auto;
    background: #fff;
    text-align: center
  }
}
}
</style>
